import "react";
import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region src/icons/document-file-icon.tsx
function n(n) {
	return /* @__PURE__ */ t("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		id: "Capa_1",
		enableBackground: "new 0 0 512 512",
		height: "512",
		viewBox: "0 0 512 512",
		width: "512",
		...n,
		children: [/* @__PURE__ */ e("path", { d: "m106 512h300c24.814 0 45-20.186 45-45v-317h-105c-24.814 0-45-20.186-45-45v-105h-195c-24.814 0-45 20.186-45 45v422c0 24.814 20.186 45 45 45zm60-301h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h120c8.291 0 15 6.709 15 15s-6.709 15-15 15h-120c-8.291 0-15-6.709-15-15s6.709-15 15-15z" }), /* @__PURE__ */ e("path", { d: "m346 120h96.211l-111.211-111.211v96.211c0 8.276 6.724 15 15 15z" })]
	});
}
//#endregion
export { n as default };
